import { isEmpty } from '@/common/utils/Util';

export default {
  setDetail: (state, data) => {
    state.detail = data;
  },
  setNoticeList: (state, list) => {
    if (isEmpty(state.noticeList)) {
      state.noticeList = list;
    } else {
      state.noticeList = [...state.noticeList, ...list];
    }
  },
  setCondition: (state, condition) => {
    Object.assign(state.condition, condition);
  },
  initPage: state => {
    state.condition.page = 1;
    state.condition.limit = 10;
    state.noticeList = [];
  }
};
